import React, { useEffect, useState } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import closeIcon from "../../images/Close-Small.svg";
import "./ImportLibraries.scss";



function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
            className="library-list customScrollBar"
        >
            {value === index && (

                <div className='libraries'>{children}</div>

            )}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export default function BasicTabs(props) {
    const { localLibrary, sharedLibrary, removeLibrary, jumpToLibraryTab } = props;
    const [value, setValue] = useState(jumpToLibraryTab);
    const [localList, setLocalList] = useState();
    const [sharedList, setSharedList] = useState();
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Box sx={{ width: '100%' }}>
            <Box className='code-editor-js-local-tab-box'>
                <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" className='code-editor-js-local-tab'>
                    <Tab label={`Local (${localLibrary?.length < 10 ? '0' + localLibrary?.length : localLibrary?.length})`} {...a11yProps(0)} className="code-editor-import-as-local" />
                    <Tab label={`Shared (${sharedLibrary?.length < 10 ? '0' + sharedLibrary?.length : sharedLibrary?.length})`} {...a11yProps(1)} className="code-editor-import-as-shared" />

                </Tabs>
            </Box>
            <TabPanel value={value} index={0}>
                {localLibrary?.map((list, indexList) => (
                    <div className='library-added'>
                        <div>{list.name}</div>
                        <div><img
                            alt="close"
                            src={closeIcon}
                            className="delete-library-closeIcon"
                            onClick={() => removeLibrary(list, indexList, 'local')}
                        ></img></div>
                    </div>
                ))}
            </TabPanel>
            <TabPanel value={value} index={1}>
                {sharedLibrary?.map((list, indexList) => (
                    <div className='library-added'>
                        <div>{list.name}</div>
                        <div><img
                            alt="close"
                            src={closeIcon}
                            className="delete-library-closeIcon"
                            onClick={() => removeLibrary(list, indexList, 'shared')}
                        ></img></div>
                    </div>
                ))}
            </TabPanel>
        </Box>
    );
}
